// src/hooks/useMediaQuery.ts
import { useEffect, useState } from "react";

type MqlWithLegacy = MediaQueryList & {
  addListener?: (listener: (this: MediaQueryList, ev: MediaQueryListEvent) => any) => void;
  removeListener?: (listener: (this: MediaQueryList, ev: MediaQueryListEvent) => any) => void;
};

export default function useMediaQuery(query: string): boolean {
  const getMatches = () => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  };

  const [matches, setMatches] = useState<boolean>(() => getMatches());

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mql = window.matchMedia(query) as MqlWithLegacy;

    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);

    // sync init
    setMatches(mql.matches);

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener?.("change", onChange);
    }

    // old Safari
    const legacyListener = () => setMatches(mql.matches);
    mql.addListener?.(legacyListener);
    return () => mql.removeListener?.(legacyListener);
  }, [query]);

  return matches;
}
